<script>
    // Bindings 
    export let max = 100;
    export let values = [10, 20];
    export let colors = ['light','green','dark'];
    export let onlyMobile = false;
    export let onlyDesktop = false;
    const getPercentage = (value, max) => {
        return ((value / max) * 100).toFixed(1);
  };

</script> 

<div class='sa-progress' class:only-mobile={onlyMobile} class:no-mobile={onlyDesktop}> 
    {#each values as value,i}
        <div class='sa-progress-bar {colors[i]}' style='width: {getPercentage(value, max)}%;'></div>
    {/each}
</div> 

<style lang='scss'>
    .sa-progress {
        width: 100%;
        height: 6px;
        background-color: #ddd;
        position: relative;
        margin: 4px 0;
        &-bar {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            background-color: color('green');
            &.light {
                background-color: color('green-light-bar') !important;
            }
            &.dark {
                background-color: color('green-dark') !important;
            }
            &.green {
                background-color: color('green') !important;
            }
            &.yellow {
                background-color: color('yellow') !important;
            }
        }
        &.only-mobile {
          display: block;
          @include desktop {
            display: none;
          }
        }
        &.no-mobile {
          display: none;
          @include desktop {
            display: block;
          }
        }
    }
</style>